<template>
    <Card :title="$t('labels.product_groups')">
        <div class="card card-table table-responsive table-scrollable shadow-0 mb-0">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>{{ $t('table.titles.product') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="product in products">
                        <td>
                            <div class="d-flex product-cell">
                                <img
                                    class="table-image mr-2"
                                    :src="product.main_image_url ?? PLACEHOLDER_IMAGE_URL"
                                    :alt="product.name"
                                />
                                <div class="text-container">
                                    <router-link :to="{ name: 'EditProductPage', params: { productUuid: product.uuid } }" class="d-block text-nowrap">
                                        {{ product.name }}
                                    </router-link>
                                    <span class="text-muted text-smaller d-block">
                                        {{ product.sku }}
                                    </span>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../../components/new/CardComponent.vue";
import { PLACEHOLDER_IMAGE_URL } from "../../../../../constants";

import { httpClient } from '../../../../../services/HttpClient';

export default {
    name: 'InternalProductGroupProductsPage',
    components: {
        Card
    },
    props: {
        groupKey: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            PLACEHOLDER_IMAGE_URL,
            products: []
        }
    },
    methods: {
        async fetchProducts() {
            const response = await httpClient.get(`/catalog/product-items`, {
                group_key: this.groupKey,
                limit: 0
            })

            this.products = response.data.data
        }
    },
    watch: {
        groupKey: {
            immediate: true,
            handler() {
                this.products = []
                this.fetchProducts()
            }
        }
    }
}
</script>
<style scoped>
.table-image {
    width: 38px;
    height: 38px;
}
.product-cell {
    max-width: 100%;
    width: 100%;
}
.text-container {
    min-width: 0;
    overflow: hidden;
    flex: 1;
}
.text-nowrap {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.text-smaller {
    font-size: 12px;
    line-height: 18px;
}
</style>
